module.exports = __webpack_public_path__ + "static/media/encouragex-primary-logo.309f2a29.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/encouragex-primary-logo.svg
// module id = 888
// module chunks = 0